<template>
<div>
  <v-row align="center">
    <v-col cols="12" class="bgc-jumbo p30-15">
      <h1 class="fw500 fOswald pl30 pr30 pt10 pb10 c-bbb fz20"><span class="fw700 c-white">{{boldText}}</span>{{heroText}}</h1>
      <div class="my-2">
        <v-btn v-if="buttonText && buttonLink" :to="buttonLink" dark medium color="#e9640a" class="fOswald fw200">{{buttonText}} <v-icon class="ml-1 mt-1">mdi-chevron-right</v-icon></v-btn>
      </div>
    </v-col>
  </v-row>
  <v-row align="center" class=" bgc-mainnav" cols="12">
    <v-col class="elevation-2 bgc-mainnav p0">
      <h2 class="fw500 fOswald pl30 pr30 pt10 pb10 c-bbb tac fz14">{{subText}}</h2>
    </v-col>
  </v-row>
</div>
</template>

<style>
  .bgc-mainnav {
    background-color: #333333;
  }
  .bgc-jumbo {
    background-color: #252525;
  }
  .p30-15 {
    padding: 30px 15px;
  }
  
</style>

<script>
export default {
  props: {
    boldText: {type: String},
    heroText: {type: String},
    subText: {type: String},
    buttonText: {type: String},
    buttonLink: {type: String}
  }
}
</script>